<template>
  <div class="pb-3">

    <!-- Titulo -->
    <div class="bg-header p-4 pb-0 mb-0">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="pt-3 d-flex align-items-center">
          <b-badge variant='dark'><i class="fa fa-info-circle"></i></b-badge>
          <strong class="ml-2">Unificación de componentes </strong>
        </h4>

        <b-button variant="danger" @click="onHandleOpenModalFormManage">
          <i class="fa fa-plus-circle"></i>
          Nueva Unificación
        </b-button>
      </div>

      <b-alert show variant="danger">
        <i class="fa fa-bell"></i>
        Es importante que cada unificación realizada sea revisada cuidadosamente antes de ser procesada ya que esta
        acción no se puede revertir.
      </b-alert>
    </div>

    <!-- Historial -->
    <div class="mt-0 pt-0">
      <TableHistory ref="tableHistoryRef" :formRef="this.$refs.modalFormManageUnifyComponentsRef" />
    </div>

    <!-- Formulario -->
    <b-modal ref="modalFormManageUnifyComponentsRef" size="xl" scrollable hide-footer no-close-on-esc
      no-close-on-backdrop hide-header-close>

      <template #modal-header="{ close }">
        <h5>{{ `${action === 'CREATE' ? 'Crear' : 'Detalles de la '} unificación de componentes` }}</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>

      <FormManage ref="formManageRef" :closeModal="closeModal" />

    </b-modal>

  </div>
</template>

<script>

// Generales
import { mapMutations, mapState } from "vuex";

// Componentes
import TableHistory from './TableHistory.vue';
import FormManage from './FormManage.vue';

export default {
  name: "unifyComponentsFormManage",

  components: {
    TableHistory,
    FormManage
  },

  computed: {

    ...mapState('unifyComponents', [
      'action'
    ]),

  },

  methods: {

    ...mapMutations("unifyComponents", [
      'setAction',
      'resetCurrentUnifyComponent'
    ]),

    onHandleOpenModalFormManage() {
      this.resetCurrentUnifyComponent();
      this.setAction('CREATE');
      this.$refs.modalFormManageUnifyComponentsRef.show()
    },

    closeModal() {
      this.resetCurrentUnifyComponent();
      this.setAction('CREATE');
      this.$refs.modalFormManageUnifyComponentsRef.hide()
    }

  }

};
</script>

<style scoped>
.bg-header {
  background-color: white;
}
</style>
